export default function SchematicsController(
  $q,
  $scope,
  loaderService,
  userService,
  ssDialogService,
  deleteSchematicsDialog,
) {
  const vm = this;

  vm.mainOfficeTitle = 'Main Office';
  vm.mainOfficeSectionId = 1;
  vm.mainOfficeSectionName = 'Main Office';

  vm.branchTitle = 'Branch';
  vm.branchSectionId = 2;
  vm.branchSectionName = 'Branch';

  vm.disasterRecoveryTitle = 'Disaster Recovery';
  vm.disasterRecoverySectionId = 3;
  vm.disasterRecoverySectionName = 'Disaster Recovery';

  vm.handleDelete = _handleDelete;

  _activate();

  /** *********************************************
   * Event Handlers
   */

  function _handleDelete($event) {
    ssDialogService.dialogs.bcp.deleteSchematicsDialog = ssDialogService.alert(
      deleteSchematicsDialog.getOptions($event, {
        assessmentId: vm.assessmentId,
        mainOfficeSchematics: vm.mainOfficeSchematics,
        branchSchematics: vm.branchSchematics,
        disasterRecoverySchematics: vm.disasterRecoverySchematics,
      })
    );
  
    ssDialogService.show(ssDialogService.dialogs.bcp.deleteSchematicsDialog);
  }

  /** *********************************************
   * Private Functions
   */

  function _activate() {
    _initEventListeners();
    _initPermissions();
  }

  function _initEventListeners() {
  }

  function _initPermissions() {
    return userService.getUserPermissionSet('bcp').then((permissions) => {
      vm.permissions = permissions;
    });
  }
}

SchematicsController.$inject = [
  '$q',
  '$scope',
  'loaderService',
  'userService',
  'ssDialogService',
  'deleteSchematicsDialog'
];
